export default "__VITE_ASSET__4RLlJKFl__"